// @flow
import { configValue } from 'utils/config';

const optimizations = ['cache=expiry:31536000', 'compress', 'no_metadata'].join(
  '/'
);

export const imageUrl = ({
  handle,
  transform,
  format,
  mimetype
}: {
  handle: string,
  transform?: string,
  format?: string,
  mimetype: string
}) => {
  if (configValue('filestack', 'mock')) {
    return `/lolz/image/${transform ? `${transform}/` : ''}${
      format ? `output=format:${format}/` : ''
    }${optimizations}/${handle}`;
  }

  // transforms are not supported for svg
  if (mimetype && mimetype.includes('image/svg')) {
    return `https://process.filestackapi.com/output=secure:true/${optimizations}/${handle}`;
  }

  return `https://process.filestackapi.com/${transform ? `${transform}/` : ''}${
    format ? `output=format:${format}/` : ''
  }${optimizations}/${handle}`;
};

// imageUrl for old uses where mimetype is not available
export const imageUrlDeprecated = ({
  handle,
  transform,
  format
}: {
  handle: string,
  transform?: string,
  format?: string
}) => imageUrl({ handle, transform, format, mimetype: '' });

export const imageSizeUrl = ({ handle }: { handle: string }) =>
  configValue('filestack', 'mock')
    ? '/lolz/image-size'
    : `https://cdn.filestackcontent.com/imagesize/${handle}`;

export const getWebpSrc = (
  src: string,
  { alwaysConvert, quality }: { alwaysConvert?: boolean, quality?: number }
) =>
  src.indexOf('output') > -1
    ? src.replace(
        /(\/output=format:)[a-z]+/g,
        '$1webp,compress:true,quality:70'
      )
    : alwaysConvert
    ? src.replace(/\.(jpg|png|gif)/g, '.webp')
    : src.replace(
        new RegExp(optimizations, 'g'),
        `output=format:webp,compress:true,quality:${quality ||
          70}/${optimizations}`
      );
